import images from './images';

const kolejWaskotorowaData = {
    title: 'Kolej Wąskotorowa',
    breadcrumb: 'Kolej Wąskotorowa',
    facebookUrl: 'https://www.facebook.com/kolejkrosniewice?locale=pl_PL',
    overview: {
        subtitle: 'Dziedzictwo Krośniewic i okolic',
        intro: 'Kolej wąskotorowa w Krośniewicach to ważny fragment lokalnej pamięci. Dla jednych była codziennym środkiem transportu, dla innych symbolem pracy, ruchu i połączenia mniejszych miejscowości z większym światem. Dziś jej historia żyje dzięki pasjonatom, którzy porządkują ślady przeszłości i przypominają o znaczeniu tego miejsca dla regionu.',
        cards: [
            {
                id: 1,
                title: 'Historia',
                text: 'Zebrane w jednym miejscu najważniejsze wątki o rozwoju, znaczeniu i przemianach kolei wąskotorowej w regionie.',
                link: '/Kolej-Waskotorowa/Historia',
            },
            {
                id: 2,
                title: 'Towarzystwo',
                text: 'Kim są ludzie, którzy podtrzymują pamięć o kolejowym dziedzictwie i jak można ich wesprzeć.',
                link: '/Kolej-Waskotorowa/Towarzystwo',
            },
            {
                id: 3,
                title: 'Galeria',
                text: 'Zdjęcia, aktualności i materiały publikowane na Facebooku, bo to tam prowadzona jest bieżąca dokumentacja.',
                link: '/Kolej-Waskotorowa/Galeria',
            },
        ],
    },
    manifesto: {
        title: 'Manifest pamięci',
        subtitle: 'Po co to wszystko?',
        lead: 'Chcemy, żeby kolej wąskotorowa w Krośniewicach była opowiadana nie tylko jako infrastruktura, ale jako historia ludzi, miejsc i codziennych połączeń.',
        points: [
            'chronić i porządkować pamiątki związane z koleją,',
            'zbierać relacje, zdjęcia i dokumenty od mieszkańców,',
            'udostępniać wiedzę w prosty i atrakcyjny sposób,',
            'łączyć pasjonatów, lokalną społeczność i kolejne pokolenia.',
        ],
        closing: 'Każdy zachowany detal i każde wspomnienie mają znaczenie.',
    },
    history: {
        title: 'Historia kolei wąskotorowej',
        subtitle: 'Najważniejsze etapy w skrócie',
        intro: 'Historia kolei wąskotorowej w Krośniewicach to opowieść o praktycznym transporcie, rozwoju regionu i późniejszym przejściu od codziennej funkcji do roli dziedzictwa kulturowego.',
        timeline: [
            {
                id: 1,
                phase: 'Początki',
                title: 'Budowa i pierwsze połączenia',
                text: 'Pierwsze odcinki linii powstawały na początku XX wieku jako odpowiedź na potrzeby rolnictwa i przemysłu lokalnego. Budowa torów i pierwsze regularne połączenia umożliwiły szybki transport płodów rolnych, drewna i materiałów budowlanych, a także znacznie przyspieszyły komunikację między wsiami a miastem. Dla mieszkańców oznaczało to łatwiejszy dostęp do rynków zbytu i nowych możliwości zarobkowych.',
                image: images.history1,
                caption: 'Fragment starej mapy linii wąskotorowej (placeholder)'
            },
            {
                id: 2,
                phase: 'Rozkwit',
                title: 'Intensyfikacja ruchu i znaczenie gospodarcze',
                text: 'W okresie międzywojennym i po II wojnie światowej ruch na liniach wąskotorowych znacznie wzrósł. Linie obsługiwały zarówno przewozy towarowe — szczególnie produkty rolne i materiały budowlane — jak i lokalne przewozy pasażerskie, łącząc okoliczne miejscowości. Intensyfikacja ruchu sprzyjała rozwojowi lokalnych zakładów oraz rozbudowie infrastruktury bocznicowej.',
                image: images.history2,
                caption: 'Wąskotorowy tabor w okresie rozkwitu (placeholder)'
            },
            {
                id: 3,
                phase: 'Infrastruktura',
                title: 'Stacje, bocznice i technika',
                text: 'Sieć wąskotorowa charakteryzowała się specyficzną infrastrukturą: małymi stacyjkami, bocznicami przy zakładach i prostymi urządzeniami manewrowymi. Tabor obejmował lekkie lokomotywy parowe i wózki towarowe przystosowane do pracy na krótkich trasach. Warsztaty i punkty obsługi technicznej, choć skromne, były kluczowe dla utrzymania ruchu.',
                image: images.history3,
                caption: 'Typowa stacja i urządzenia bocznicowe (placeholder)'
            },
            {
                id: 4,
                phase: 'Zmiana',
                title: 'Zmniejszanie roli i zamknięcia odcinków',
                text: 'W drugiej połowie XX wieku nastąpiła istotna zmiana w sposobie transportu: rozwój komunikacji drogowej i wzrost dostępności samochodów spowodowały spadek zapotrzebowania na przewozy wąskotorowe. Wiele odcinków zostało z czasem zamkniętych, a infrastruktura — torowiska i budynki — popadła w zaniedbanie lub została zlikwidowana. Był to proces obejmujący zmiany gospodarcze, organizacyjne i technologiczne.',
                image: images.kolej4,
                caption: 'Zaniedbane torowisko przed renowacją (placeholder)'
            },
            {
                id: 5,
                phase: 'Ocalanie',
                title: 'Akcje społeczne i dokumentacja',
                text: 'W obliczu zanikania fizycznych śladów kolei, lokalne społeczności i pasjonaci rozpoczęli działania mające na celu ocalenie pamięci i fragmentów infrastruktury. Powstawały zbiory fotografii, relacji ustnych, a także inicjatywy sprzątania torowisk, konserwacji wagonów i organizowania wystaw historycznych. Dzięki temu część linii i eksponatów uzyskała szansę na rewitalizację lub wykorzystanie w celach edukacyjnych i turystycznych.',
                image: images.kolej5,
                caption: 'Wolontariusze dbający o relikty kolei (placeholder)'
            },
            {
                id: 6,
                phase: 'Dziś',
                title: 'Edukacja i pamięć',
                text: 'Obecnie kolej wąskotorowa funkcjonuje przede wszystkim jako nośnik pamięci i element lokalnego dziedzictwa kulturowego. Organizowane są wydarzenia edukacyjne, przejazdy turystyczne i pokazowe, a także projekty współpracy z muzeami i szkołami. Działania te mają na celu zachowanie wiedzy o linii, promocję regionu i stworzenie trwałej oferty turystycznej opartej na historii i tożsamości miejsca.',
                image: images.kolej6,
                caption: 'Współczesne spotkanie dokumentacyjne (placeholder)'
            },
        ],
    },
    society: {
        title: 'Towarzystwo kolei wąskotorowej w Krośniewicach',
        subtitle: 'Pasjonaci, którzy trzymają to w ruchu',
        intro: 'Towarzystwo skupia osoby, które chcą ocalać i promować lokalne dziedzictwo kolejowe. Ich praca opiera się na dokumentowaniu, porządkowaniu materiałów i utrzymywaniu kontaktu z mieszkańcami oraz sympatykami kolei.',
        blocks: [
            {
                id: 1,
                title: 'Co robi towarzystwo?',
                text: 'Gromadzi wspomnienia, zdjęcia, materiały archiwalne i informacje o dawnym funkcjonowaniu kolei. Dzięki temu można budować rzetelną opowieść o miejscu, które dla wielu osób jest częścią lokalnej tożsamości.',
            },
            {
                id: 2,
                title: 'Dla kogo jest ta inicjatywa?',
                text: 'Dla mieszkańców, pasjonatów kolei, osób zainteresowanych historią regionu i wszystkich, którzy chcą pomóc w zachowaniu pamięci o wąskotorówce.',
            },
            {
                id: 3,
                title: 'Jak można dołączyć?',
                text: 'Najprościej przez kontakt na Facebooku, śledzenie publikacji i udostępnianie własnych materiałów, jeśli ktoś ma fotografie, relacje albo dokumenty związane z koleją.',
            },
        ],
    },
    gallery: {
        title: 'Galeria i aktualności',
        subtitle: 'Najwięcej materiałów jest na Facebooku',
        intro: 'Ponieważ towarzystwo nie prowadzi własnej rozbudowanej strony, galeria zdjęć, bieżące informacje i krótkie aktualności najlepiej sprawdzają się na Facebooku. Tam można śledzić nowe publikacje i zobaczyć archiwalne oraz współczesne materiały w jednym miejscu.',
        images: [
            images.kolej1,
            images.kolej2,
            images.kolej3,
            images.kolej4,
            images.kolej5,
            images.kolej6,
        ],
        highlights: [
            'fotografie archiwalne i współczesne',
            'krótkie przypomnienia o historii linii',
            'informacje o spotkaniach i działaniach społecznych',
            'materiały udostępniane przez sympatyków kolei',
        ],
    },
};

export default kolejWaskotorowaData;